// @flow

/* Libs */
import React from 'react';
import { Route, Switch } from 'react-router-dom';

/* Components */
import ListProducts from './ListProducts';

/* Styles */
import './Products.scss';

const Furnitures = () => (
	<div className="App-Furnitures">
		<Switch>
			<Route path="/inventory/products" exact>
				<ListProducts />
			</Route>

			<Route path="/inventory/products/:productid">
				<ListProducts />
			</Route>

			<Route path="/inventory/products/new">
				<ListProducts />
			</Route>
		</Switch>
	</div>
);

export default Furnitures;
